import React, { useEffect } from 'react';
import DropdownPreviewItem from './DropdownPreviewItem';
import DropdownTextLinkItem from './DropdownTextLinkItem';
import CaretDownIcon from '../icons/CaretDownIcon';
import useWindowSize from '../../utils/useWindowSize';
import useHoverDropdown from '../../utils/useHoverDropdown';
import { contextDispatch, contextState } from '../../utils/ContextProvider';
import styles from './DropdownNav.module.css';

/**
 *
 * @param {(FF.HeaderNavPreviewItem | FF.HeaderNavTextItem)} navItem
 */
function getNavItemByType(navItem) {
  if (navItem.type === 'text-link') {
    return <DropdownTextLinkItem navItem={navItem} />;
  }
  if (navItem.type === 'preview-with-button') {
    return <DropdownPreviewItem navItem={navItem} />;
  }
  throw new Error('nav item type not found');
}

/**
 *
 * @param {FF.HeaderNavDropdownProps} props
 */
export default function DropdownNav({
  buttonClass = '',
  currentPage,
  navItemActiveClass = '',
  navItemClass = '',
  navItems,
  title,
}) {
  const { contextData } = contextState();
  const dispatch = contextDispatch();

  const {
    isShowing,
    closeDropdown,
    openDropdown,
    useHoverRef,
    toggleHoverHandling,
  } = useHoverDropdown();

  const windowSize = useWindowSize();

  useEffect(() => {
    closeDropdown(true);
    toggleHoverHandling(!windowSize?.isMobileView);
  }, [windowSize?.isMobileView]);

  useEffect(() => {
    if (isShowing) {
      dispatch({
        contextData: {
          ...contextData,
          activeNavHoverId: title,
        },
        type: 'set',
      });
    }
  }, [isShowing]);

  useEffect(() => {
    if (contextData.activeNavHoverId !== title) {
      closeDropdown(true);
    }
  }, [contextData.activeNavHoverId]);

  const isActive = navItems.some(({ url }) => currentPage?.includes(url));

  return (
    <li
      className={`${styles.dropdownNav} ${
        isActive ? navItemActiveClass : navItemClass
      }`}
    >
      <button
        aria-label={`Show all ${title}`}
        className={`${styles.dropdownButton} ${buttonClass}`}
        onClick={() => (isShowing ? closeDropdown(true) : openDropdown())}
        ref={useHoverRef()}
        type="button"
      >
        {title}
        <CaretDownIcon
          className={isShowing ? styles.caretDownFlipped : styles.caretDown}
        />
      </button>
      <svg
        aria-hidden="true"
        className={
          isShowing ? styles.hoverTriangleOpen : styles.hoverTriangleHidden
        }
        // @ts-ignore, no reason why SVG cant have a ref
        ref={useHoverRef()}
        viewBox="0,0,440,50"
      >
        <polygon fill="transparent" points="64,0 140,0 440,50 0,50" />
      </svg>
      <aside
        className={
          isShowing ? styles.dropdownModalOpen : styles.dropdownModalHidden
        }
        ref={useHoverRef()}
      >
        <div className={styles.triangle} />
        <ul className={styles.dropdownNavItems}>
          {navItems.map(navItem => {
            let key;
            if (navItem.type === 'preview-with-button') {
              key = navItem.title;
            } else if (navItem.type === 'text-link') {
              key = navItem.label;
            }
            return (
              <React.Fragment key={key}>
                {getNavItemByType(navItem)}
              </React.Fragment>
            );
          })}
        </ul>
      </aside>
    </li>
  );
}
